import React from 'react';
import SubServices from '../common/sub-services';

const CareerServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <h2
                            className="text-primary  mb-2 fs-xl fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="100"
                        >
                            What Makes Us Happy
                        </h2>
                        <p data-aos="fade-up fs-mdlg fw-400 mb-0" data-aos-duration="700" data-aos-delay="200">
                            We work in a people-centric place. Where our core focus is on individual creation, work execution, and
                            operation. We want them to be happy with work and also work happily!
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2">
                    <SubServices
                        path={'/img/technology/ic-home.svg'}
                        height={64}
                        width={64}
                        alt="home"
                        title="home"
                        serviceName="Hybrid Working Model"
                        serviceDescription="We have a strong affinity for our office, but we are committed to aligning with the needs of our resources."
                    />
                    <SubServices
                        path={'/img/technology/ic-timing.svg'}
                        height={64}
                        width={64}
                        alt="timing"
                        title="timing"
                        serviceName="Flexible Timings"
                        serviceDescription="To empower employees to manage things in a fast-paced life."
                    />
                    <SubServices
                        path={'/img/technology/ic-tranning-session.svg'}
                        height={64}
                        width={64}
                        alt="user-interface"
                        title="user-interface"
                        serviceName="Training Session"
                        serviceDescription="Practical training & learning from the experts and mentors."
                    />
                    <SubServices
                        path={'/img/technology/ic-team.svg'}
                        height={64}
                        width={64}
                        alt="team"
                        title="team"
                        serviceName="Team Building"
                        serviceDescription="Indoor & outdoor team building workshops and activities."
                    />
                    <SubServices
                        path={'/img/technology/ic-health-insurance.svg'}
                        height={64}
                        width={64}
                        alt="vaction"
                        title="vaction"
                        serviceName="Health Insurance"
                        serviceDescription="Comprehensive health cover for every member of an organization."
                    />
                    <SubServices
                        path={'/img/technology/ic-reward.svg'}
                        height={64}
                        width={64}
                        alt="reward"
                        title="reward"
                        serviceName="Rewards"
                        serviceDescription="We make it a priority to regularly acknowledge and appreciate outstanding performance."
                    />
                </div>
            </div>
        </div>
    );
};

export default CareerServies;
